/** Parse `{ success, error, message }` or FastAPI `{ detail }` from an API response body. */
export function parseIdpApiErrorBody(data: unknown, fallback: string): string {
  if (data && typeof data === 'object') {
    const record = data as Record<string, unknown>;
    if (typeof record.error === 'string' && record.error.trim()) {
      return record.error.trim();
    }
    if (typeof record.message === 'string' && record.message.trim()) {
      return record.message.trim();
    }
    const detail = record.detail;
    if (typeof detail === 'string' && detail.trim()) {
      return detail.trim();
    }
  }
  return fallback;
}

/** User-facing message for a failed IDP fetch (never raw HTTP library text). */
export function idpFetchErrorMessage(
  response: Response,
  data: unknown,
  fallback: string
): string {
  const fromBody = parseIdpApiErrorBody(data, '');
  if (fromBody) return fromBody;

  if (response.status === 503) {
    return 'Document processing service is temporarily unavailable.';
  }
  if (response.status === 502) {
    return 'Document processing service is unavailable.';
  }
  if (response.status >= 500) {
    return `${fallback} (server error)`;
  }
  if (response.status >= 400) {
    return `${fallback} (HTTP ${response.status})`;
  }
  return fallback;
}
